import React, { Component } from 'react'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import _, { toNumber } from "lodash";
import moment from "moment";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";

import Autocomplete from "../../../component/autocomplete";
import Modal from '../../../component/modal';
import request from "../../../lib/requester";


class CreateProgram extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      success: '',
      error: [],
      Program_Company: '9',
      Program_Refnumber: '',
      Program_Type: '',
      Program_Description: '',
      Program_Budgettype: '',
			Program_Assignmenttype: '',
      Program_Startdate: new Date(),
      Program_Enddate: new Date(),
      Program_Claimexp: new Date(),
      Program_Budget: '',
      Program_Salestarget: '',
      Program_Customerpphtype: 'Tidak Potong PPh',
      Program_Pphrate: '0',
      Program_Participant: '',
      Program_Notes: '',
      Participant_Total: 0,
      Participant_Name: [],
      lovDocument: [],
      lovProgramMember: [],
      lovBudget: [],
      lovCompany: [],
      lovProgramType: [],
      lovPPhType: [],
      lovParticipant: [],
			lovAssignment: ['One Time', 'Multiple'],
      documentList: [],
      productList: [{ item_id: "", item_desc: "", item_reff: "", item_budget: "" }],
      showParticipant: false,
      participant: {},
      fileContainer: {},
      user: JSON.parse(window.localStorage.getItem("is_user"))
    }
  }

  componentDidMount = () => {
    this.getMasterData()
  }

  getMasterData = () => {
    let url = '/api/traces_chd/v1/program/data-master'
    request.getCHD(url, {
      success: function (response) {
        let { Company, BudgetType, ProgramDocument, ProgramPPhType, ProgramMemberType } = response.data.data
        this.setState({
          lovCompany: Company,
          lovBudget: BudgetType,
          lovDocument: ProgramDocument,
          lovPPhType: ProgramPPhType,
          lovProgramMember: ProgramMemberType
        })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
    this.getDataProgramType();
  }

  getDataProgramType = () => {
    let orgId = this.state.Program_Company || '9'
    if (!orgId || orgId.length === 0) {
      this.setState({ lovProgramType: [], Program_Type: '' })
      return
    }

    let url = '/api/traces_chd/v1/program/data-program?org_id=' + (orgId || '')
    request.getCHD(url, {
      success: function (response) {
        let { ProgramType } = response.data.data
        this.setState({
          lovProgramType: ProgramType
        })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  renderLovBudget = () => {
    return (
      <select value={this.state.Program_Budgettype} className="col-md-8 form-control" name="Program_Budgettype" onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Budget Type -</option>
        {
          this.state.lovBudget.map((item, index) => (
            <option value={item.budget_type_id} key={index}>{item.budget_type}</option>
          ))
        }
      </select>
    )
  }

  renderLovAssignment = () => {
    return (
      <select value={this.state.Program_Assignmenttype} className="col-md-8 form-control" name="Program_Assignmenttype" onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Customer Assignment Type -</option>
        {
          this.state.lovAssignment.map((val, index) => (
            <option value={val} key={index}>{val}</option>
          ))
        }
      </select>
    )
  }

  renderLovCompany = () => {
    return (
      <select value={9} disabled className="col-md-8 form-control" name="Program_Company" onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Company -</option>
        {
          this.state.lovCompany.map((item, index) => (
            <option value={item.org_id} key={index}>{item.org_name}</option>
          ))
        }
      </select>
    )
  }

  renderLovProgramType = () => {
    return (
      <select className="col-md-8 form-control" name="Program_Type" onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Program -</option>
        {
          this.state.lovProgramType.map((item, index) => (
            <option value={item.prog_type_id} key={index}>{item.program_name}</option>
          ))
        }
      </select>
    )
  }

  renderLovPPH = () => {
    return (
      <select className="col-md-8 form-control" name="Program_Customerpphtype" value={this.state.Program_Customerpphtype} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select PPh Type -</option>
        {
          this.state.lovPPhType.map((item, index) => (
            <option value={item.pph_type} key={index}>{item.pph_type}</option>
          ))
        }
      </select>
    )
  }

  formProgram = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light font-size-title">
              Program
            </div>
            <div className="multi-collapse show" id="multiCollapseExample2">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Company</label>
                      {this.renderLovCompany()}
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Reff Number / IM</label>
                      <input type="text" className="form-control col-md-8" autoComplete="off" onChange={this.handleChangeInput.bind(this)} name="Program_Refnumber" value={this.state.Program_Refnumber} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Type</label>
                      {this.renderLovProgramType()}
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Description</label>
                      <input type="text" className="form-control col-md-8" autoComplete="off" name="Program_Description" onChange={this.handleChangeInput.bind(this)} value={this.state.Program_Description} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget Type</label>
                      {this.renderLovBudget()}
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Customer Assignment Type</label>
                      {this.renderLovAssignment()}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Start Date</label>
                      <div className="col-sm-3 pl-0">
                        <DatePicker
                          selected={this.state.Program_Startdate}
                          dateFormat="d-MMM-yyyy"
                          className="form-control"
                          popperPlacement="top-end"
                          onChange={this.handleStartDate}
                        />
                      </div>
                      <label className="col-md-2 mt-1">End Date</label>
                      <div className="col-sm-3">
                        <DatePicker
                          selected={this.state.Program_Enddate}
                          dateFormat="d-MMM-yyyy"
                          className="form-control"
                          popperPlacement="top-end"
                          onChange={this.handleEndDate}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Claim Exp Date</label>
                      <div className="col-md-3 pl-0">
                        <DatePicker
                          selected={this.state.Program_Claimexp}
                          dateFormat="d-MMM-yyyy"
                          className="form-control"
                          popperPlacement="top-end"
                          onChange={this.handleExpDate}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget</label>
                      <input type="text" className="form-control col-md-8" autoComplete="off" name="Program_Budget" onChange={this.handleChangeInput.bind(this)} value={this.state.Program_Budget} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Sales Target</label>
                      <input type="text" className="form-control col-md-8" autoComplete="off" name="Program_Salestarget" onChange={this.handleChangeInput.bind(this)} value={this.state.Program_Salestarget} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Customer PPH Type</label>
                      {this.renderLovPPH()}
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">PPh Rate (%)</label>
                      <input type="number" className="form-control col-md-8" name="Program_Pphrate" disabled={this.state.Program_Customerpphtype === 'Tidak Potong PPh' ? true : false} onChange={this.handleChangeInput.bind(this)} value={this.state.Program_Pphrate} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  formDocument = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light">
              <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#multiCollapseExample3" role="button" aria-expanded="true" aria-controls="multiCollapseExample3">Claim Documents <i className="fas fa-chevron-down font-size-small text-muted" /></a>
            </div>
            <div className="multi-collapse show" id="multiCollapseExample3">
              <div className="card-body">
                <div className="row">
                  {this.renderListDocument()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  formParticipant = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light">
              <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#multiCollapseExample6" role="button" aria-expanded="true" aria-controls="multiCollapseExample6">Participants <i className="fas fa-chevron-down font-size-small text-muted" /></a>
            </div>
            <div className="multi-collapse show" id="multiCollapseExample6">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Participants Type</label>
                      <div className="col-sm-8">
                        {this.renderLovProgramMember()}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Participant</label>
                      {this.renderParticipant()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  formProduct = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light">
              <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#multiCollapseExample5" role="button" aria-expanded="true" aria-controls="multiCollapseExample2">Products <i className="fas fa-chevron-down font-size-small text-muted" /></a>
            </div>
            <div className="multi-collapse show" id="multiCollapseExample5">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-12">
                    {this.renderProduct()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  renderParticipant = () => {
    let { showParticipant } = this.state
    if (showParticipant) {
      return (
        <div className="col-md-8">
          <select className="form-control multiselect-height" name="Participant_Name" multiple onChange={this.handleMultiSelect.bind(this)}>
            {
              this.state.lovParticipant.map((item, index) => (
                <option key={index}>{item.NAME}</option>
              ))
            }
          </select>
          <small>(*) press ctrl + click to multiple select</small>
        </div>
      )
    }
  };

  handleMultiSelect = (e) => {
    var options = e.target.options;
    var value = [];
    for (var i = 0, l = options.length; i < l; i++) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }
    this.setState({ Participant_Name: value });
  }

  onChangeAutocompleteParticipant = (description) => {
    let container = [];
    let app = this
    let membertype = _.find(this.state.lovProgramMember, function (o) {
      return parseInt(o.program_member_id) === parseInt(app.state.Program_Participant)
    })
    console.log(membertype)
    let param = {
      query: description,
      type: membertype.description || ''
    };

    return new Promise((resolve) => {
      request.postCHD("/api/traces_chd/v1/participant/list", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.NAME;
            item.value = item.NAME;
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  }

  onSelectParticipant = (item, index) => {
    this.setState({ Participant_Name: item.value })
  }

  renderLovProgramMember = () => {
    return (
      <select className="form-control" name="Program_Participant" onChange={this.handleChangeParticipant.bind(this)}>
        <option>- Select Participants -</option>
        {this.state.lovProgramMember.map((item, index) => (
          <option value={item.program_member_id} key={index}>
            {item.description}
          </option>
        ))}
      </select>
    );
  }

  renderListDocument = () => {
    return this.state.lovDocument.map((item, index) => (
      <div className="col-md-4" key={index}>
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            value={item.document_id}
            onClick={this.handleClickDocument.bind(this)}
            id="defaultCheck1"
          />
          <label className="form-check-label" htmlFor="defaultCheck1">
            {item.document_name}
          </label>
        </div>
      </div>
    ));
  }

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { documentList } = this.state;
    if (is_checked) {
      documentList.push({ documentId: docId });
    } else {
      let getIndex = _.findIndex(documentList, function (o) {
        return parseInt(o.documentId) === parseInt(docId);
      });
      documentList.splice(getIndex, 1);
    }
    this.setState(documentList);
  };

  handleStartDate = (date) => {
    this.setState({ Program_Startdate: date });
  };

  handleEndDate = (date) => {
    this.setState({ Program_Enddate: date });
  };

  handleExpDate = (date) => {
    this.setState({ Program_Claimexp: date });
  };

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    if (name === "Program_Budget" || name === "Program_Salestarget") {
      value = this.thousandSeparator(value);
    }

    if (name === "Program_Customerpphtype" && value === "Tidak Potong PPh") {
      this.setState({ Program_Pphrate: 0 });
    }

    if(name == 'Program_Type'){
      if(value == 1){
        this.setState({
          Program_Budgettype: '4',
          Program_Assignmenttype: 'One Time'
        })
      }else if(value == 3){
        this.setState({
          Program_Budgettype: '4',
          Program_Assignmenttype: 'Multiple'
        })
      }
    }

    this.setState({ [name]: value });
    let app = this;
    window.setTimeout(() => {
      if (name === "Program_Company") {
        app.getDataProgramType();
      }
      if (name === "Program_Customerpphtype" && value === "Tidak Potong PPh") {
        app.setState({ Program_Pphrate: 0 });
      }
    }, 100);
  };

  handleChangeParticipant = (e) => {
    let value = e.target.value;

    let membertype = _.find(this.state.lovProgramMember, function (o) {
      return parseInt(o.program_member_id) === parseInt(value)
    })

    let url = '/api/traces_chd/v1/participant/list'
    let param = {
      type: membertype ? membertype.description : ''
    }
    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data
        this.setState({ Program_Participant: value, Participant_Name: '', showParticipant: false, lovParticipant: data, loading: false });
        let app = this
        window.setTimeout(() => {
          app.setState({ showParticipant: true })
        }, 200)
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false})
      }.bind(this)
    })
  };

  handleChangeType = (value) => {
    let find = _.find(this.state.lovProgramMember, function (o) {
      return o.program_member_id === parseInt(value);
    });
    let type = find ? find.description : "";
    this.setState({ memberId: value, memberType: type });

    let { participant } = this.state;
    participant.customer_id = null;
    participant.participant = null;
    if (type === "Customer") {
      this.setState({ showParticipant: false });
    } else {
      this.setState({ showParticipant: true });
    }
  };

  onSelectProduct = (item, index) => {
    let { productList } = this.state;
    productList[index].item_id = item.value;
    productList[index].item_desc = item.text;
    productList[index].item_brand_chd = item.BRAND_CHD || ''
    productList[index].item_brand_group = item.PRODUCT_GROUP || ''
    this.setState(productList)
  };

  onChangeProductReff = (event) => {
    let value = event.target.value;
    let currentindex = event.target.attributes.getNamedItem("currentindex").value;
    let { productList } = this.state;

    productList[currentindex].item_reff = value;
    this.setState(productList)

    let app = this
    window.setTimeout(() => {
      console.log(currentindex)
      console.log(app.state.productList)
    })
  };

  onChangeProductBudget = (event) => {
    let value = event.target.value.length > 0 ? event.target.value : "";
    let currentindex = event.target.attributes.getNamedItem("currentindex").value;
    let { productList } = this.state;

    productList[currentindex].item_budget = this.thousandSeparator(value);
    this.setState(productList)
  };

  onChangeAutocomplete = (index, description) => {
    let container = [];
    let param = {
      query: description,
    };

    return new Promise((resolve) => {
      request.postCHD("/api/traces_chd/v1/product/list", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.PRODUCT_DESC;
            item.value = item.PRODUCT_ID;
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  };

  replicateProduct = () => {
    let { productList } = this.state;
    productList.push({
      item_id: "", // this.state.productID
      item_desc: "", // this.state.productDESC
      item_reff: "",
      item_budget: "",
    });
    this.setState(productList);
  };

  removeProduct = (index) => {
    if (this.state.productList.length === 1) {
      alert("You must have at least 1 product");
      return false;
    }
    let { productList } = this.state;
    productList.splice(index, 1);
    this.setState(productList)
  };

  renderAddProduct = () => {
    let app = this;
    let principalCode = _.find(this.state.lovCompany, function (o) {
      return parseInt(o.org_id) === parseInt(app.state.Program_Company);
    });

    return (
      <div className="form-group row">
        <div className="col-sm-4">
          <Autocomplete id="productDefine" onchange={this.onChangeAutocomplete.bind(this)} principalCode={principalCode} onselect={this.onSelectProduct.bind(this)} />
        </div>
        <div className="col-sm-2">
          <button type="button" onClick={this.replicateProduct.bind(this)} className="btn btn-success">+</button>{" "} &nbsp;
        </div>
      </div>
    );
  };

  renderProduct = () => {
    let app = this;
    let principalCode = _.find(this.state.lovCompany, function (o) {
      return parseInt(o.org_id) === parseInt(app.state.Program_Company);
    });

    return this.state.productList.map((item, index) => (
      <div className="form-group row" key={index}>
        <div className="col-sm-4">
          <Autocomplete onchange={this.onChangeAutocomplete.bind(this, index)} isDisabled={item.item_id === "" ? false : true} currentvalue={item.item_desc} currentIndex={index} principalCode={principalCode} onselect={this.onSelectProduct.bind(this)} />
        </div>
        <div className="col-sm-2">
          <input type="text" className="form-control" autoComplete="off" name="itemBudget" placeholder="Budget" currentindex={index} value={item.item_budget} onChange={this.onChangeProductBudget.bind(this)} />
        </div>
        <div>
          <button type="button" onClick={this.replicateProduct.bind(this)} className="btn btn-success rounded-circle"><i className="fa fa-plus fa-xs" /></button> &nbsp;
          <button type="button" onClick={() => { this.removeProduct(index); }} className="btn btn-danger rounded-circle" ><i className="fa fa-minus fa-xs" /></button> &nbsp;
          {item.item_id !== "" ? <button type="button" className="btn btn-primary rounded-circle" onClick={() => { this.editProduct(index); }}><i className="fa fa-pencil-alt fa-xs" /></button> : ""}
        </div>
      </div>
    ));
  };

  formNotes = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light font-size-title">
              Notes
            </div>
            <div className="multi-collapse show" id="multiCollapseExample7">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <textarea className="form-control" name="Program_Notes" rows={5} value={this.state.Program_Notes} onChange={this.handleChangeInput.bind(this)}></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  formAttachment = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header bg-light font-size-title">
              Attachments
            </div>
            <div className="multi-collapse show" id="multiCollapseExample7">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">
                        Attachment
                    </label>
                      <div className="col-sm-8">
                        <input type="file" className="form-control" onChange={this.uploadFile.bind(this)} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }

  formButton = () => {
    return (
      <div className="row mt-1">
        <div className="col-md-3">
          <button type="button" className="btn btn-primary btn-block" onClick={this.handleSubmit.bind(this)}><i className="fa fa-save" />&nbsp; Save Program</button>
        </div>
      </div>
    )
  }

  uploadFile = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = [
      "jpg",
      "png",
      "jpeg",
      "gif",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "csv",
      "pdf",
    ];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobodyCHD("/api/traces_chd/v1/util/upload-file", data, {
      success: function (response) {
        let data = response.data;
        this.setState({ fileContainer: data, loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      },
    });
  };

  thousandSeparator = (value) => {
    if (!value || value.length === 0) return

    value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  removeSeparator = (value) => {
    if (!value || value.length === 0) {
      return
    }
    value = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    return value;
  };

  handleSubmit = () => {
    if (this.formValidation()) {
      let app = this
      let principalCode = _.find(this.state.lovCompany, function (o) {
        return parseInt(o.org_id) === parseInt(app.state.Program_Company);
      });

      let url = '/api/traces_chd/v1/program/submit'
      let param = {
        ref_number: this.state.Program_Refnumber,
        org_id: this.state.Program_Company,
        description: this.state.Program_Description,
        start_date: (this.state.Program_Startdate) ? moment(this.state.Program_Startdate).format('YYYY-MM-DD') : '',
        end_date: (this.state.Program_Enddate) ? moment(this.state.Program_Enddate).format('YYYY-MM-DD') : '',
        claim_exp_date: (this.state.Program_Claimexp) ? moment(this.state.Program_Claimexp).format('YYYY-MM-DD') : '',
        prog_type_id: this.state.Program_Type,
        budget_type_id: this.state.Program_Budgettype,
				customer_assignment_type: this.state.Program_Assignmenttype,
        budget: this.state.Program_Budget ? this.removeSeparator(this.state.Program_Budget) : '0',
        sales_target: this.state.Program_Salestarget ? this.removeSeparator(this.state.Program_Salestarget) : '0',
        pph_type: this.state.Program_Customerpphtype,
        pph_rate: this.state.Program_Pphrate,
        participant_type: this.state.Program_Participant,
        notes: this.state.Program_Notes,
        created_by: this.state.user.user_id,
        principal_code: principalCode.org_initial || '',
        product_list: this.state.productList,
        document_list: this.state.documentList,
        document_upload: this.state.fileContainer,
        participant_list: this.state.Participant_Name
      }

      this.setState({ loading: true })
      request.postCHD(url, param, {
        success: function (response) {
          let { message } = response.data
          this.setState({ success: message, loading: false })
          window.scrollTo(0, 0)

          window.setTimeout(() => {
            window.location.reload()
          }, 3000)
        }.bind(this),
        error: function (e) {
          let message = e.response.data ? e.response.data.message : "There's an error while submitting your request..."
          this.setState({ error: [message], loading: false })

          window.scrollTo(0, 0)
        }.bind(this)
      })
    }
  }

  formValidation = () => {
    let error = [];

    let { productList } = this.state
    let totalAmountProduct = 0
    productList.forEach((item, index) => {
      totalAmountProduct += parseInt(this.removeSeparator(item.item_budget || 0))
    })

    if (this.state.Program_Company === '' || this.state.Program_Company.length === 0) {
      error.push('Principal is required')
    }
    if (this.state.Program_Description === '' || this.state.Program_Description.length === 0) {
      error.push('Description is required')
    }
    if (this.state.Program_Type === '' || this.state.Program_Type.length === '') {
      error.push('Program Type is required')
    }
    if (this.state.Program_Budgettype === '' || this.state.Program_Budgettype.length === 0) {
      error.push('Program Budget Type is required')
    }
    if (this.state.Program_Assignmenttype === '' || this.state.Program_Assignmenttype.length === 0) {
      error.push('Customer Assignment Type is required')
    }
    if (this.state.Program_Refnumber === '' || this.state.Program_Refnumber.length === 0) {
      error.push('Program Ref Number is required')
    }
    if (this.state.Program_Budget === '' || this.state.Program_Budget.length === 0) {
      error.push('Program Budget is required')
    }
    if (this.state.Program_Salestarget === '' || this.state.Program_Salestarget.length === 0) {
      error.push('Program Sales Target is required')
    }
    if (this.state.documentList.length === 0) {
      error.push("You must have at least 1 document");
    }
    if (this.state.Program_Participant === "") {
      error.push("Please Select Participant Type");
    }
    if (totalAmountProduct > 0 && totalAmountProduct !== parseInt(this.removeSeparator(this.state.Program_Budget))) {
      error.push('Total budget of products must be 0 or equal with budget program')
    }
    if (this.state.Participant_Name.length === 0) {
      error.push('Please Select Participant List')
    }

    this.setState({ error: error })
    if (error.length > 0) {
      window.scrollTo(0, 0)
      return false
    } else {
      return true
    }
  }

  editProduct = (index) => {
    let { productList } = this.state
    productList[index].item_id = ''
    productList[index].item_desc = ''
    this.setState(productList)
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-body">
                    {this.showNotification()}
                    <form className="form-horizontal">
                      {this.formProgram()}
                      {this.formDocument()}
                      {this.formParticipant()}
                      {this.formProduct()}
                      {this.formNotes()}
                      {this.formAttachment()}
                      {this.formButton()}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
          <Modal isOpen={true} title="OK" body="BODY" />
        </section>
      </div>
    )
  }
}

export default CreateProgram